import './CurrentPasswordModal.scss';
import { CurrentPassword } from './form-items';
import { SonarModal } from './modals';
import { Alert, Form } from 'antd';
import React, { useCallback, useRef } from 'react';
export const CurrentPasswordModal = ({ disabled, error, errorMessage, failed, failedMessage, onCancel, onOk, open }) => {
    const formRef = useRef(null);
    const handleOnOkClick = useCallback(() => {
        const { current } = formRef;
        if (current) {
            const currentPassword = current.getFieldValue('currentPassword');
            onOk(currentPassword);
            current.resetFields();
        }
    }, [onOk]);
    return (React.createElement(SonarModal, { centered: true, className: 'current-password-modal', onCancel: onCancel, onOk: handleOnOkClick, open: open, title: 'Password Confirmation' },
        React.createElement(Form, { ref: formRef },
            error && React.createElement(Alert, { message: errorMessage, type: 'error' }),
            failed && React.createElement(Alert, { message: failedMessage, type: 'error' }),
            React.createElement(CurrentPassword, { disabled: disabled, id: 'modal-password' }))));
};
